var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customer-welcome"},[_vm._v("Hi"),_c('transition',{attrs:{"name":"fast-fade"}},[(_vm.name)?_c('span',[_vm._v(", "+_vm._s(_vm.name))]):_vm._e()]),_vm._v("!")],1)}
var staticRenderFns = []

export { render, staticRenderFns }